import { NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { RadiosErrorFieldComponent } from '@components/radios-error-field/radios-error-field.component';
import { QuestionnaireAnswers } from '@enums/questionnaire-answers';
import { SelectableOption } from '@models/selectable-option';

@Component({
  selector: 'app-radio-buttons-question-card',
  templateUrl: './radio-buttons-question-card.component.html',
  styleUrls: ['./radio-buttons-question-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [NgIf, RadiosErrorFieldComponent, NgFor],
})
export class RadioButtonsQuestionCardComponent {
  @Input() public buttonText: string;
  @Input() public displayButton: boolean = true;
  @Input() public controlName: string;
  @Input() public form: FormGroup;
  @Input() public hints: string[] = [];
  @Input() public question: string;
  @Input() public processing: boolean = false;
  @Input() public options: SelectableOption[] = [
    new SelectableOption(QuestionnaireAnswers.Yes),
    new SelectableOption(QuestionnaireAnswers.No),
  ];
  @Input() public title: string;
  @Output() public buttonClick = new EventEmitter<void>();
}
